// extracted by mini-css-extract-plugin
export var activityContainer = "_lr-0";
export var typingIndicatorContainer = "_lr-1";
export var typingIndicatorDot = "_lr-2";
export var wave = "_lr-3";